import applicationService from '@/services/ApplicationService.js';

export default {
  async getApplicationFile(context, { objectName, contentType }) {
    return await applicationService.GetFile(objectName, contentType);
  },

  async loadForm(context, jobofferId) {
    const response = await applicationService.LoadForm(jobofferId);
    return await response.json();
  },

  async loadRequestedInformation(context, { applicationId, actionId, token }) {
    const response = await applicationService.LoadRequestedInformation(
      applicationId,
      actionId,
      token
    );
    if (!response.ok) {
      return null;
    }
    return await response.json();
  },

  async loadApplicationData(context, { applicationId, email, token }) {
    const response = await applicationService.LoadApplicationData(
      applicationId,
      email,
      token
    );

    if (!response.ok) {
      return null;
    }

    return await response.json();
  },

  async parseCvFile(context, { application, objectId, formId, jobofferId }) {
    return await applicationService.ParseCv(
      application,
      objectId,
      formId,
      jobofferId
    );
  },

  async saveApplication(context, data) {
    return await applicationService.SaveApplication(data);
  },

  async submitApplication(context, data) {
    return await applicationService.SubmitApplication(data);
  },

  async updateApplicationData(context, data) {
    return await applicationService.UpdateApplicationData(data);
  },

  async updateAppointment(context, data) {
    return await applicationService.UpdateAppointment(data);
  },

  async getInterviewSuggestions(context, { applicationId, authToken }) {
    const response = await applicationService.GetInterviewSuggestions(
      applicationId,
      authToken
    );

    if (!response.ok) {
      return null;
    }

    return await response.json();
  },

  async selectInterviewSuggestion(context, data) {
    return await applicationService.SelectInterviewSuggestion(data);
  },

  async uploadFile(context, fileData) {
    return await applicationService.UploadFile(
      fileData.file,
      fileData.fileType
    );
  }
};
